import * as React from "react";
import { useState, useEffect } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  Form,
  Col,
  Row,
} from "react-bootstrap";
import { BsSearch, BsFileEarmarkExcel, BsFileEarmarkPdf } from "react-icons/bs";
import CatVacaciones from "../../../Services/Catalogos/CatVacaciones";
import DTOVacaciones from "../../Catalogos/CatVacaciones/DTO/DTOVacaciones";
import CatEmpleados from "../../../Services/Catalogos/CatEmpleados";
import DTOEmpleadoVac from "../../Catalogos/CatEmpleados/DTO/DTOEmpleadoVac";
import { MsgInformativo } from "../../../Utils/Toast/msgInformativo";
import DTOFirmasResponse from "../../../DTO/Reportes/DTOFirmasResponse";
import { Modal } from "react-bootstrap";

export default function VacacionAccepted() {
  const [Data, setData] = useState<Array<DTOVacaciones>>([]);
  const [filteredData, setFilteredData] = useState<Array<DTOVacaciones>>([]);
  const [Inicio, setInicio] = useState(currentDate());
  const [Fin, setFin] = useState(currentDate());
  const [filtro, setFiltro] = useState("");
  const [userData, setUserData] = useState<DTOEmpleadoVac[]>([]); 
  const [superFirma, setSuperFirma] = useState<string | null>(null);
  const [tipoReporte, setTipoReporte] = useState<"Aceptadas" | "Pendientes" | "Procesadas" | "Todas"  >("Aceptadas");
  const [confirmShow, setConfirmShow] = useState(false);
const [rowSeleccionado, setRowSeleccionado] = useState<DTOVacaciones | null>(null);


  

// Agrega estos estados
    const [detalleTexto, setDetalleTexto] = useState("");
    const [showDetalle, setShowDetalle] = useState(false);

    // Función para mostrar el detalle
    const mostrarDetalle = (texto: string) => {
      setDetalleTexto(texto || "Sin información");
      setShowDetalle(true);
    };



  
   const [show, setShowMsg] = useState(false)
        const [msg, setMsg] = useState('')
        const [header, setHeader] = useState('')
        const msgColor = 'primary'

  useEffect(() => {
    loadUserData();
  }, []);


  useEffect(() => {
    const correo = localStorage.getItem("correoSupervisor"); // Ajusta el nombre de la clave
    if (correo) {
      loadSuperFirma(correo);
    }
  }, []);
  


  const formatearFecha = (fecha: string) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };
  
 const confirmarCambioProcesado = (row: DTOVacaciones) => {
  setRowSeleccionado(row);
  setConfirmShow(true);
};


const procesarRH = async () => {
  if (!rowSeleccionado) return;
  try {
    const nuevoEstado = !rowSeleccionado.procesadaRh;
    await CatVacaciones.marcarProcesadaRh(rowSeleccionado.id, nuevoEstado);
    
    setConfirmShow(false);
    setRowSeleccionado(null);
    generarReporte(); // 👈 recarga con filtro aplicado
  } catch (error) {
    console.error("❌ Error al marcar como procesada:", error);
  }
};


  
  
  const formatearFechaISO = (fecha: string | string[]): string => {
  if (!fecha) return "No especificado"; // Si es null o undefined

  // Si es un string separado por comas, lo convertimos en un array
  if (typeof fecha === "string" && fecha.includes(",")) {
    return fecha.split(",").map((f) => formatearFechaISO(f.trim())).join(", ");
  }

  // Si es un array, formateamos cada fecha individualmente
  if (Array.isArray(fecha)) {
    return fecha.length > 0
      ? fecha.map((f) => formatearFechaISO(f)).join(", ")
      : "No especificado";
  }

  // Si la fecha es un string individual, la formateamos a DD/MM/YYYY
  const partes = fecha.split("-");
  return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : "Formato inválido";
};


  function currentDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

 






const generarReporte = () => {
  CatVacaciones.getAllSoVacaciones(Inicio, Fin, tipoReporte)
    .then((response) => {
      setData(response.data);
      setFilteredData(response.data);
      setHeader("Informativo");
      setMsg("Se encontró la siguiente información");
      setShowMsg(true);
    })
    .catch((error: any) => {
      const errorMessage =
        error.response?.data?.message || "Error al cargar los datos.";
      console.error("Error al obtener los datos:", error);
      setHeader("Error");
      setMsg(errorMessage);
      setShowMsg(true);
    });
};

    

  const loadUserData = () => {
    const userIdString = localStorage.getItem("UserId");

    if (!userIdString) {
      console.error("No se encontró el UserId en el localStorage.");
      return;
    }

    const userId = Number(JSON.parse(userIdString));

    if (isNaN(userId) || userId <= 0) {
      console.error("El UserId recuperado no es válido:", userId);
      return;
    }

    CatEmpleados.GetIdEmpleado(userId)
      .then((response) => {
        if (response.data.length > 0) {
          setUserData(response.data);
        } else {
          console.error("La API no devolvió datos para el usuario.");
        }
      })
      .catch((e: Error) => {
        console.error("Error al llamar a la API:", e);
      });
  };




  



const loadSuperFirma = async (numEmpleado: string) => {
  try {
    const response = await CatEmpleados.GetSuperFirma(numEmpleado);

    if (response.data) {
      const { numSupervisor, numEmpleadoRH , numEmpleado } = response.data as DTOFirmasResponse;

      if (numSupervisor) {
        setSuperFirma(numSupervisor);
        return numEmpleado;
      } else if (numEmpleadoRH) {
        setSuperFirma(numEmpleadoRH);
        return numEmpleadoRH;
      } else if(numEmpleado ) {
        setSuperFirma(numEmpleado)
        return numEmpleado
      }
      
      else {
        return null;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.error("❌ Error al obtener la firma del supervisor:", e);
    return null;
  }
};


  
  

  
  

  const generarPDF = async (row: DTOVacaciones) => {
    

    const year = new Date().getFullYear();
    const periodoVacaciones = `${year - 1}-${year}`;
  
    
    const response = await CatEmpleados.GetSuperFirma(row.numEmpleado);
    const numSupervisor = response.data?.numSupervisor || null;
    const numRh = response.data?.numEmpleadoRH || null;
    const numEmpleado = response.data?.numEmpleado || null;
  
    
    let firmaSupervisor = null;
    let firmaRh = null;
    let firmaEmpleado = null;
  
    try {
      if (numSupervisor) {
        firmaSupervisor = await CatEmpleados.GetFotoFirma(numSupervisor, 'firma');
      }
      if (numRh) {
        firmaRh = await CatEmpleados.GetFotoFirma(numRh, 'firma');
      }
      if (numEmpleado) {
        firmaEmpleado = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');
      }
    } catch (error) {
      console.error('Error al obtener las firmas:', error);
    }
  

    const ventana = window.open("", "_blank");

    if (!ventana) {
        alert("Tu navegador bloquea ventanas emergentes. Habilítalas para generar el PDF.");
        return;
    }

    ventana.document.write(`
        <html>
        <head>
            
            <style>
                @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

                body {
                    font-family: Arial, sans-serif;
                    padding: 20px;
                    background-color: #f4f4f4;
                    text-align: center;
                }
                .container {
                    max-width: 750px;
                    margin: auto;
                    background: #ffffff;
                    border: 3px solid #1e3a8a;
                    border-radius: 10px;
                    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
                    padding: 20px;
                    text-align: left;
                }
                h2 {
                    text-align: center;
                    color: #1e3a8a;
                    margin-bottom: 10px;
                }
                .header-info {
                    text-align: right;
                    font-size: 14px;
                    font-weight: bold;
                    color: #444;
                }
                .intro-text {
                    font-size: 14px;
                    font-weight: bold;
                    margin-bottom: 15px;
                    padding: 10px;
                    background: #e3f2fd;
                    border-left: 4px solid #1e3a8a;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                }
                td {
                    padding: 10px;
                    font-size: 14px;
                    border-bottom: 1px solid #1e3a8a;
                }
                td:first-child {
                    font-weight: bold;
                    width: 40%;
                }
                .icon {
                    margin-right: 8px;
                    color: #1e3a8a;
                }
                .logo {
                    width: 70px;
                    float: left;
                    margin-right: 15px;
                }
                
                  .firma {
                    width: 120px;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 10px auto;
                    border: 2px dashed #555;
                    padding: 5px;
                    background-color: #fff;
                  }

                  .firma img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                  }



               
                .firma-texto {
                    text-align: center;
                    font-weight: bold;
                    margin-top: 5px;
                }
                .firma-seccion {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    padding: 5px 20px;
                }
                .footer {
                    background: linear-gradient(to right, #7cb9e8, #1e3a8a);
                    color: #ffffff;
                    padding: 10px;
                    text-align: center;
                    margin-top: 30px;
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-radius: 5px;
                }
                .footer span {
                    flex: 1;
                    text-align: center;
                    font-size: 13px;
                }
                .footer a {
                    color: #ffffff;
                    text-decoration: none;
                    font-weight: bold;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <img src="GEMCO.png" class="logo" alt="Logo GEMCO"/>
                <h2>SOLICITUD DE VACACIONES</h2>

                <p class="header-info">Nuevo Laredo, Tamaulipas a ${formatearFecha(row.fechaSolicitud)}</p>

                <p class="intro-text">
                    De acuerdo con mi antigüedad en esta Empresa, me permito solicitar mis vacaciones 
                    correspondientes al ejercicio <b>${periodoVacaciones}</b> de acuerdo con la siguiente información:
                </p>

                <table>

                        <tr>
                          <td><i class="fa-solid fa-calendar-check icon"></i> Fecha Ingreso:</td>
                          <td>${formatearFecha(row.fechaIngreso)}</td>    
                      </tr>

                     <tr>
                        <td><i class="fa-solid fa-id-badge icon"></i> Nombre:</td>
                        <td>${row.nombre}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-id-badge icon"></i> Número de Empleado:</td>
                        <td>${row.numEmpleado}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-calendar icon"></i> Años de Antigüedad:</td>
                        <td>${row.anosServicio}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-calendar-check icon"></i> Días de Vacaciones:</td>
                        <td>${row.diasVacaciones}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-file-signature icon"></i> Tipo de Solicitud:</td>
                        <td>${row.tipoSolicitud}</td>
                    </tr>

                     <tr>
                        <td><i class="fa-solid fa-sun icon"></i> Días a Disfrutar:</td>
                        <td>${formatearFechaISO(row.diasSalteados)}</td>
                      </tr>

                    <tr>
                        <td><i class="fa-solid fa-plane-departure icon"></i> Días a Tomar:</td>
                        <td>${row.diasTomar}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-money-check-alt icon"></i> Días a Pagar:</td>
                        <td>${row.diasPagar}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-plane-departure icon"></i> Días Restantes Descansar:</td>
                        <td>${row.diasRestantes}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-money-check-alt icon"></i> Días Restantes Pagar:</td>
                        <td>${row.diasPorPagar}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-comments icon"></i> Comentario:</td>
                        <td>${row.comentario ? row.comentario : "N/A"}</td>
                    </tr>
                    <tr>
                        <td><i class="fa-solid fa-circle-check icon"></i> Estado:</td>
                        <td>${row.estado}</td>
                    </tr>
                </table>

                <div class="firma-seccion">
                    <div class="firma"><img src="${firmaSupervisor}" alt="Firma del Supervisor"></div>
                    <div class="firma"><img src="${firmaEmpleado}" alt="Firma del Usuario"></div>
                    <div class="firma"><img src="${firmaRh}" alt="Firma de RH"></div>

                    </div>
                </div>
            </div>

            <div class="footer">
                <span>Mendoza 907 Col. Centro</span>
                <span>Nuevo Laredo, Tam C.P. 88000</span>
                <span>Tel. (867) 712-30-64</span>
                <span><a href="https://gemcousa.com">gemcousa.com</a></span>
            </div>

            <script>
                setTimeout(() => { window.print(); window.close(); }, 500);
            </script>
        </body>
        </html>
    `);

    ventana.document.close();
};


//  .firma {
//                     width: auto;
//                     max-width: 150px;
//                     max-height: 100px;
//                     display: block;
//                     margin: 10px auto;
//                     border: 2px dashed #555;
//                     padding: 10px;
//                     text-align: center;
//                     object-fit: contain;
//                 }  cambio del tamano de firmas 


//  <div>    cambios de tamanos de firmas
//                         ${firmaSupervisor ? `<img src="${firmaSupervisor}" class="firma" alt="Firma del supervisor"/>` : "<p class='firma'>No se encontró firma</p>"}
//                         <p class="firma-texto">Firma del Supervisor</p>
//                     </div>
//                     <div>
//                         ${firmaEmpleado ? `<img src="${firmaEmpleado}" class="firma" alt="Firma del Empleado"/>` : "<p class='firma'>No se encontró firma</p>"}
//                         <p class="firma-texto">Firma del Usuario</p>
//                     </div>

//                     <div>
//                         ${firmaRh ? `<img src="${firmaRh}" class="firma" alt="Firma de rh"/>` : "<p class='firma'>No se encontró firma</p>"}
//                         <p class="firma-texto">Firma de RH</p>
//                     </div>
  
  const filtraReporte = (e: any) => {
    const searchText = e.target.value.toLowerCase();
    setFiltro(searchText);

    const filtered = Data.filter((item) => {
      return (
        (item.numEmpleado && item.numEmpleado.toString().toUpperCase().includes(searchText)) ||
        (item.fechaSolicitud && item.fechaSolicitud.toString().toLowerCase().includes(searchText)) || 
        (item.nombre && item.nombre.toString().toLocaleLowerCase().includes(searchText)  )

      );
    });

    setFilteredData(filtered);
  };

  const donwloadExel = () => {
    const filteredColumns = filteredData.map(
      ({ numEmpleado, nombre,tipoSolicitud, diasTomar, diasPagar, diaPago, diasSalteados, fechaSolicitud, observaciones  }) => ({
        numEmpleado,
        nombre, 
        tipoSolicitud,
        diasTomar,
        diasPagar,
        diaPago, 
        diasSalteados,
        fechaSolicitud,
        observaciones
        
      })
    );
    exportExcel(filteredColumns, "RptVacaciones");
  };

  

  const exportExcel = (jsonData: any[], fileName: string) => {
  // 🧾 Encabezado visual elegante
  const Heading = [
    [
      "🏖️ REPORTE DE VACACIONES - GEMCO",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    ["📅 Generado el: " + new Date().toLocaleDateString("es-MX")],
    [],
    [
      "🆔 Nº Empleado",
      "👤 Nombre",
      "📄 Tipo Solicitud",
      "☀️ Días Tomar",
      "💰 Días Pagar",
      "📆 Día de Pago",
      "🗓️ Días Solicitados",
      "🕓 Fecha Solicitud",
      "💬 Observaciones",
    ],
  ];

  // 💎 Datos visuales con íconos — sin cambiar funcionalidad
  const formattedData = jsonData.map((row) => ({
    "🆔 Nº Empleado": `#${row.numEmpleado || "-"}`,
    "👤 Nombre": row.nombre?.toUpperCase() || "—",
    "📄 Tipo Solicitud": row.tipoSolicitud ? `📋 ${row.tipoSolicitud}` : "—",
    "☀️ Días Tomar": row.diasTomar > 0 ? `☀️ ${row.diasTomar}` : "—",
    "💰 Días Pagar": row.diasPagar > 0 ? `💵 ${row.diasPagar}` : "—",
    "📆 Día de Pago": row.diaPago ? `📅 ${row.diaPago}` : "—",
    "🗓️ Días Solicitados": row.diasSalteados || "—",
    "🕓 Fecha Solicitud": row.fechaSolicitud || "—",
    "💬 Observaciones": row.observaciones || "Sin observaciones",
  }));

  // 📘 Crear workbook y hoja
  const wb = XLSX.utils.book_new();
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

  XLSX.utils.sheet_add_aoa(ws, Heading);
  XLSX.utils.sheet_add_json(ws, formattedData, { origin: "A5", skipHeader: true });

  // 🧩 Ajuste automático de ancho de columnas
  ws["!cols"] = [
    { wch: 15 }, // Nº Empleado
    { wch: 25 }, // Nombre
    { wch: 25 }, // Tipo Solicitud
    { wch: 15 }, // Días Tomar
    { wch: 15 }, // Días Pagar
    { wch: 18 }, // Día de Pago
    { wch: 28 }, // Días Solicitados
    { wch: 20 }, // Fecha Solicitud
    { wch: 40 }, // Observaciones
  ];

  // 📗 Agregar hoja
  XLSX.utils.book_append_sheet(wb, ws, "Vacaciones");

  // 💾 Descargar
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

  
  const columnsConcepts: TableColumn<DTOVacaciones>[] = [

    {

      name: "Id", 
      width: "30", 
      selector: (row: DTOVacaciones) => row.id, 
      sortable: true
    }, 
    {
      name: "Nombre", 
      width: "150px", 
      selector: (row : DTOVacaciones) => row.nombre, 
      sortable: true
    }, 
    {
      name: "NumeroEmpleado",
      width: "150px",
      selector: (row: DTOVacaciones) => row.numEmpleado,
      sortable: true,
    },
    {
      name: "TipoSolicitud",
      width: "180px",
      selector: (row: DTOVacaciones) => row.tipoSolicitud,
      sortable: true,
    },
    {
      name: "FechaIngreso", 
      width: "150px", 
      selector: (row: DTOVacaciones) =>  formatearFecha(row.fechaIngreso), 
      sortable : true, 

    }, 
    {
      name: "AñosAntiguedad", 
      width: "150px", 
      selector: (row: DTOVacaciones) => row.anosServicio, 
      sortable:  true, 
    }, 
    {
      name: "DiasVacaciones", 
      width: "150px", 
      selector: (row: DTOVacaciones) => row.diasVacaciones, 
      sortable: true, 
    }, 
    {
      name: "DiasTomar",
      width: "150px",
      selector: (row: DTOVacaciones) => row.diasTomar,
      sortable: true,
    },
    {
      name: "DiasPagar",
      width: "150px",
      selector: (row: DTOVacaciones) => row.diasPagar,
      sortable: true,
    },

       {
      name: 'Día que se Pagará',
      selector: (row: DTOVacaciones) => {
        if (!row.diaPago) return '—';
    
        try {
          // Detecta si viene como DateTime string tipo "11/13/2025 12:00:00 AM"
          const dateValue =
            typeof row.diaPago === 'string'
              ? new Date(row.diaPago.replace(' AM', '').replace(' PM', '')) // limpia hora
              : new Date(row.diaPago);
    
          // Evita Invalid Date
          if (isNaN(dateValue.getTime())) return '—';
    
          return dateValue.toLocaleDateString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          });
        } catch {
          return '—';
        }
      },
      sortable: true,
      width: '150px',
    },
    
    
    {
  name: "DiasSolicitados",
  width: "200px",
  selector: (row: DTOVacaciones) =>
    formatearFechaISO(row.diasSalteados).length > 30
      ? formatearFechaISO(row.diasSalteados).slice(0, 30) + "..."
      : formatearFechaISO(row.diasSalteados),
  sortable: true,
  cell: (row) => {
    const diasFormateados = formatearFechaISO(row.diasSalteados);
    return (
      <div onDoubleClick={() => mostrarDetalle(diasFormateados)}>
        {diasFormateados.length > 30
          ? diasFormateados.slice(0, 30) + "..."
          : diasFormateados}
      </div>
    );
  },
}, 

    // {
    //   name: "DiasRestantesPorDescansar", 
    //   width : "200px", 
    //   selector: (row: DTOVacaciones)  => row.diasRestantes, 
    //   sortable: true
    // }, 
    // {
    //   name: "DiasRestantesPorPagar", 
    //   width: "200px", 
    //   selector: (row: DTOVacaciones) => row.diasPorPagar, 
    //   sortable: true 
    // }, 

    {
  name: "DiasRestantesPorDescansar",
  width: "200px",
  selector: (row: DTOVacaciones) =>
    row.origen === "PreRegistro" ? "Pendiente de cálculo" : row.diasRestantes,
  sortable: true
},
{
  name: "DiasRestantesPorPagar",
  width: "200px",
  selector: (row: DTOVacaciones) =>
    row.origen === "PreRegistro" ? "Pendiente de cálculo" : row.diasPorPagar,
  sortable: true
},




    {
      name: "FechaSolicitud",
      width: "200px",
      selector: (row: DTOVacaciones) => formatearFecha(row.fechaSolicitud),
      sortable: true,
    },
    {
      name: "FechaAceptacionSolicitud",
      width: "200px",
      selector: (row: DTOVacaciones) => formatearFecha(row.fechaAceptacionSolicitud),
      sortable: true,
    },
    
    {
      name: "Estado",
      width: "100px",
      selector: (row: DTOVacaciones) => row.estado,
      sortable: true,
    },
    

    {
      name: "Comentario",
      width: "150px", // más compacto
      selector: (row: DTOVacaciones) =>
        row.comentario && row.comentario.length > 30
          ? row.comentario.slice(0, 30) + "..."
          : row.comentario,
      cell: (row) => (
        <div onDoubleClick={() => mostrarDetalle(row.comentario)}>
          {row.comentario && row.comentario.length > 30
            ? row.comentario.slice(0, 30) + "..."
            : row.comentario}
        </div>
      ),
    },
    {
      name: "Observaciones",
      width: "150px", // más compacto
      selector: (row: DTOVacaciones) =>
        row.observaciones && row.observaciones.length > 30
          ? row.observaciones.slice(0, 30) + "..."
          : row.observaciones,
      cell: (row) => (
        <div onDoubleClick={() => mostrarDetalle(row.observaciones)}>
          {row.observaciones && row.observaciones.length > 30
            ? row.observaciones.slice(0, 30) + "..."
            : row.observaciones}
        </div>
      ),
    },
    {
  name: "Origen",
  width: "140px",
  // selector: (row: DTOVacaciones) => row.origen || "",
  
  sortable: true,
},
{
  name: "EstatusProceso",
  width: "250px",
  selector: (row: DTOVacaciones) => row.estatusProceso || "",
  sortable: true,
},
// {
//   name: "CicloInicio",
//   width: "150px",
//   selector: (row: DTOVacaciones) => row.cicloInicio ? formatearFecha(row.cicloInicio) : "—",
//   sortable: true,
// },









    {
      name: "Acciones",
      width: "120px",
      cell: (row) => (
        <Button variant="danger" size="sm" onClick={() => generarPDF(row)}>
          <BsFileEarmarkPdf /> PDF
        </Button>
      ),
    }, 

{
  name: "Procesada",
  width: "120px",
  cell: (row: DTOVacaciones) => {
    const isChecked = !!row.procesadaRh;

    const bgColor = isChecked ? "#7AC142" : "#005377"; // Verde o azul oscuro
    const iconColor = "white";

    return (
      <div
        style={{
          backgroundColor: bgColor,
          width: "32px",
          height: "32px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={(e) => {
          e.stopPropagation(); // Previene conflicto con clic de fila
          confirmarCambioProcesado(row); // ✅ Abre modal
        }}
      >
        {isChecked ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={iconColor}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          </svg>
        )}
      </div>
    );
  },
  sortable: true,
}, 
  

];


//   const conditionalRowStyles = [
    
//   {
//     when: (row: DTOVacaciones) => row.procesadaRh === true,
//     style: {
//       backgroundColor: '#d4edda', // verde claro de fondo fila
//       color: '#155724',
//       cursor: 'pointer',
//     },
//   },
//   {
//     when: (row: DTOVacaciones) => row.procesadaRh === false,
//     style: {
//       backgroundColor: '#fff3cd', // amarillo claro
//       color: '#856404',
//       cursor: 'pointer',
//     },
//   },
//   {
//     when: (row: DTOVacaciones) => row.estado === 'Pendiente'  ,
//     style: {
//       backgroundColor: '#f8d7da', // rojo claro
//       color: '#721c24',
//       cursor: 'pointer',
//     },
//   },
// ];

const conditionalRowStyles = [
  {
    when: (row: DTOVacaciones) => row.procesadaRh === true,
    style: {
      backgroundColor: '#d4edda',
      color: '#155724',
      cursor: 'pointer',
    },
  },
  {
    when: (row: DTOVacaciones) => row.procesadaRh === false,
    style: {
      backgroundColor: '#fff3cd',
      color: '#856404',
      cursor: 'pointer',
    },
  },
  {
    when: (row: DTOVacaciones) => row.estado === 'Pendiente',
    style: {
      backgroundColor: '#f8d7da',
      color: '#721c24',
      cursor: 'pointer',
    },
  },
  {
    when: (row: DTOVacaciones) => row.origen === 'PreRegistro',
    style: {
      backgroundColor: '#ffcc99',
      color: '#663c00',
      cursor: 'pointer',
      fontWeight: 600,
    },
  },
];

const handleRowClicked = async (row: DTOVacaciones) => {
  try {
    const nuevoEstado = !row.procesadaRh;
    await CatVacaciones.marcarProcesadaRh(row.id, nuevoEstado);
    const newData = filteredData.map((item) =>
      item.id === row.id ? { ...item, procesadaRh: nuevoEstado } : item
    );
    setFilteredData(newData);
  } catch (error) {
    console.error("Error al actualizar estado RH:", error);
  }
};





return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(120deg, #f3f4f6, #fafaf9)",
      padding: "30px",
      fontFamily: "'Inter', sans-serif",
      color: "#1f2937",
    }}
  >
    <Card
      style={{
        borderRadius: "16px",
        background: "#ffffff",
        boxShadow: "0 4px 25px rgba(0,0,0,0.08)",
        padding: "25px",
        border: "1px solid #e5e7eb",
        transition: "all 0.3s ease",
      }}
    >
      <Form>
        <Row className="align-items-end g-3">
          <Col xs={2}>
            <Form.Label style={{ fontWeight: 600 }}>Desde</Form.Label>
            <Form.Control
              type="date"
              value={Inicio}
              onChange={(e) => setInicio(e.target.value)}
              size="sm"
              style={{
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </Col>

          <Col xs={2}>
            <Form.Label style={{ fontWeight: 600 }}>Hasta</Form.Label>
            <Form.Control
              type="date"
              value={Fin}
              onChange={(e) => setFin(e.target.value)}
              size="sm"
              style={{
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </Col>

          <Col xs={3}>
            <Form.Label style={{ fontWeight: 600 }}>Buscar</Form.Label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Buscar empleado "
              onChange={filtraReporte}
              style={{
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
                padding: "7px",
              }}
            />
          </Col>

          <Col xs={2}>
            <Form.Label style={{ fontWeight: 600 }}>Tipo de Reporte</Form.Label>
            <Form.Select
              size="sm"
              value={tipoReporte}
              onChange={(e) =>
                setTipoReporte(
                  e.target.value as
                    | "Aceptadas"
                    | "Pendientes"
                    | "Procesadas"
                    | "Todas"
                )
              }
              style={{
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            >
              <option value="aceptadas">Aceptadas</option>
              <option value="pendientes">Pendientes</option>
              <option value="procesadas">Procesadas</option>
              <option value="DiasSalteados">Días Solicitados</option>
              <option value="DiaPago">Días que se pagarán</option>
              <option value="DiasSolicitadosYPago">DiasSolicitadosYPago</option>
              <option value="todas">Todas</option>
            </Form.Select>
          </Col>

          <Col xs={3} style={{ textAlign: "right" }}>
            <Button
              variant="dark"
              onClick={generarReporte}
              style={{
                borderRadius: "10px",
                marginRight: "8px",
                background: "#111827",
                border: "none",
                padding: "7px 14px",
                fontWeight: "600",
                boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
              }}
            >
              <BsSearch /> Buscar
            </Button>
            <Button
              variant="outline-success"
              onClick={donwloadExel}
              style={{
                borderRadius: "10px",
                fontWeight: "600",
                border: "2px solid #059669",
                color: "#065f46",
                backgroundColor: "white",
                padding: "7px 14px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#059669";
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white";
                e.currentTarget.style.color = "#065f46";
              }}
            >
              <BsFileEarmarkExcel /> Excel
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>

    <Card
      className="mt-4"
      style={{
        borderRadius: "14px",
        background: "#ffffff",
        boxShadow: "0 6px 25px rgba(0,0,0,0.07)",
        border: "1px solid #e5e7eb",
      }}
    >
      <Card.Body>
        <DataTable
          noHeader
          defaultSortAsc={true}
          striped
          dense
          pagination
          highlightOnHover
          columns={columnsConcepts}
          data={filteredData}
          pointerOnHover
          conditionalRowStyles={conditionalRowStyles}
        />
      </Card.Body>
    </Card>

    <Modal show={showDetalle} onHide={() => setShowDetalle(false)} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#374151", color: "white" }}
      >
        <Modal.Title>Detalle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ whiteSpace: "pre-wrap", color: "#111827" }}>{detalleTexto}</p>
      </Modal.Body>
    </Modal>

    <Modal show={confirmShow} onHide={() => setConfirmShow(false)} centered>
      <Modal.Header
        closeButton
        style={{
          background: rowSeleccionado?.procesadaRh ? "#991b1b" : "#14532d",
          color: "white",
        }}
      >
        <Modal.Title>
          {rowSeleccionado?.procesadaRh
            ? "Desmarcar solicitud procesada"
            : "Marcar solicitud como procesada"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {rowSeleccionado?.procesadaRh
          ? "¿Deseas revertir el estado de esta solicitud?"
          : "¿Deseas marcar esta solicitud como procesada por RH?"}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setConfirmShow(false)}>
          Cancelar
        </Button>
        <Button
          variant={rowSeleccionado?.procesadaRh ? "danger" : "success"}
          onClick={procesarRH}
        >
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>

    <MsgInformativo
      show={show}
      msg={msg}
      header={header}
      msgColor={msgColor}
      closeToast={() => setShowMsg(false)}
    />

    <style>
      {`
        .rdt_TableRow:hover {
          transition: all 0.3s ease;
          background-color: #f3f4f6 !important;
        }
      `}
    </style>
  </div>
);
}